import { isEmpty } from 'lodash';
import { MonitoringSeriesTypeEnum } from '../enums/monitoring-series-type.enum';
import { DateQueryModel } from '../../../Common/Forms/models/date-query.model';
import { MentionSearchCriteriaModel } from './mention-search-criteria.model';
import { MentionModel } from '../../../api/mentions/model/mention.model';

export class MonitoringBackEndDataSourceModel {
    type: MonitoringSeriesTypeEnum;
    id: number;
    dataSourceName?: string;
    referenceId?: string;
    sourceSearchCriteria?: MentionSearchCriteriaModel;
    filterSearchCriteria?: MentionSearchCriteriaModel;
    combinedSearchCriteria?: MentionSearchCriteriaModel;
    curatedMentionCount?: number;
    dynamicMentionCount?: number;
    mentions?: MentionModel[];

    constructor(
        type: MonitoringSeriesTypeEnum,
        id: number = null
    ) {
        this.type = type;
        this.id = id;
        this.sourceSearchCriteria = new MentionSearchCriteriaModel();
        this.sourceSearchCriteria.query.dateQuery = null;
        this.sourceSearchCriteria.facets = MentionSearchCriteriaModel.accountSearchFacets;
        this.sourceSearchCriteria.dateFacets = [];
        this.filterSearchCriteria = new MentionSearchCriteriaModel();
        this.combinedSearchCriteria = new MentionSearchCriteriaModel();

        switch (this.type) {
            case MonitoringSeriesTypeEnum.allSavedCoverage:
            case MonitoringSeriesTypeEnum.folder:
            case MonitoringSeriesTypeEnum.tag:
            case MonitoringSeriesTypeEnum.tagGroup:
            case MonitoringSeriesTypeEnum.aiAgent:
                this.filterSearchCriteria.query.dateQuery = DateQueryModel.getAllQuery();
                break;
            case MonitoringSeriesTypeEnum.topic:
            case MonitoringSeriesTypeEnum.subscription:
            case MonitoringSeriesTypeEnum.socialTopic:
            case MonitoringSeriesTypeEnum.theme:
                this.filterSearchCriteria.query.dateQuery = DateQueryModel.getLast24HoursQuery();
                break;
        }

        this.sourceSearchCriteria.query.keywordGroups = [];
    }

    isSavedSource(): boolean {
        switch (this.type) {
            case MonitoringSeriesTypeEnum.allSavedCoverage:
            case MonitoringSeriesTypeEnum.folder:
            case MonitoringSeriesTypeEnum.tag:
            case MonitoringSeriesTypeEnum.tagGroup:
            case MonitoringSeriesTypeEnum.aiAgent:
                return true;
        }
        return false;
    }

    isUnsavedSource(): boolean {
        switch (this.type) {
            case MonitoringSeriesTypeEnum.socialTopic:
            case MonitoringSeriesTypeEnum.sourceGroup:
            case MonitoringSeriesTypeEnum.subscription:
            case MonitoringSeriesTypeEnum.theme:
            case MonitoringSeriesTypeEnum.topic:
            case MonitoringSeriesTypeEnum.currentSearch:
                return true;
        }
        return false;
    }

    equals(other: MonitoringBackEndDataSourceModel, checkSourceSearchCriteria: boolean = true): boolean {
        if (!other) {
            return false;
        }

        if (this.type !== other.type) {
            return false;
        }

        if (this.id !== other.id) {
            if (!isEmpty(this.id) && isEmpty(other.id)) {
                return false;
            }
        }

        if (this.dataSourceName !== other.dataSourceName) {
            return false;
        }

        if (this.referenceId !== other.referenceId) {
            return false;
        }

        if ( checkSourceSearchCriteria &&
            (!!this.sourceSearchCriteria !== !!other.sourceSearchCriteria ||
            (
                this.sourceSearchCriteria &&
                !this.sourceSearchCriteria.equals(other.sourceSearchCriteria)
            )
            )) {
            return false;
        }

        if (
            !!this.filterSearchCriteria !== !!other.filterSearchCriteria ||
            (
                this.filterSearchCriteria &&
                !this.filterSearchCriteria.equals(other.filterSearchCriteria)
            )
        ) {
            return false;
        }

        return true;
    }

    clone(): MonitoringBackEndDataSourceModel {
        const clone = new MonitoringBackEndDataSourceModel(this.type, this.id);
        clone.dataSourceName = this.dataSourceName;
        clone.sourceSearchCriteria = this.sourceSearchCriteria?.clone();
        clone.filterSearchCriteria = this.filterSearchCriteria?.clone();
        clone.combinedSearchCriteria = this.combinedSearchCriteria?.clone();
        if (this.referenceId) {
            clone.referenceId = this.referenceId;
        }

        return clone;
    }
}
